import React from 'react'
//import shared from '../../../../testing/students/shared'
import customRequest from '../../../../helpers/customRequest'
import { initializeFormValidation } from '../../../../helpers/forms/form-validation'
import getURLParams from '../../../../helpers/getURLParams'
import message from '../../../../components/message/message'
import redirect from '../../../../components/redirect/redirect'
import ClipLoader from 'react-spinners/ClipLoader'

class Edit extends React.Component
{
    state = {
        permission: {},
        readPermission: false,
        writePermission: false,
        submitting: false,
        loading: true
    }

    componentDidMount()
    {
        let params = getURLParams()

        customRequest.get('/api/students/share')
        .then(({data}) => {
            if (data.valid) {
                var shared = data.permissions
                for (var i = 0; i < shared.length; i++)
                {
                    var permission = shared[i]
                    if (permission.customer == params.customer && permission.student == params.student)
                    {
                        this.setState({permission: permission, readPermission: permission.read, writePermission: permission.write, loading: false})
                        return
                    }
                }
            }

            redirect.send("/students/share/manage", () => {
                message.error("There has been an error finding your permission. Please try again.")
            })
        })

        initializeFormValidation(this.onSubmit);
        }

        onSubmit = () => {
            this.setState({submitting: true, loading: true}, () =>
            {
                let params = getURLParams()
                var permissions = []

                if (this.state.readPermission) {
                    permissions.push("read")
                }

                if (this.state.writePermission) {
                    permissions.push("write")
                }

                customRequest.post('/api/students/share', {
                    students: [params.student],
                    permissions: permissions,
                    shareToCustomer: params.customer
                })
                .then(({data}) => {
                    this.setState({submitting: false, loading: false})
                    if (data.valid) {
                        redirect.send('/students/share/manage', () => {
                            message.success('Permissions have been successfully edited.')
                        })
                    } else {
                        message.error(data.message)
                    }
                })
            })
        }

    render()
    {
        var {permission, readPermission, writePermission, loading, submitting} = this.state
        return (
            <React.Fragment>
                <h1>Edit Student Sharing Setting</h1>
                <div class = "row subheader-text">
                    <div class = "col-sm-10 offset-sm-1 col-md-8 offset-md-2">
                        <p>Please select or deselect permission types to delegate, or uncheck all permissions to revoke this sharing setting.</p>
                    </div>
                </div>

                <form class = "form-horizontal form-validate" noValidate method = "post">
                    <div class = "form-group row">
                        <label class = "text-center-xs bold-xs col-sm-3 control-label text-right">Student</label>
                        
                        <div class = "col-sm-6">
                            <p class = "form-control-static text-left text-center-xs break-words">{permission.student}</p>
                        </div>
                    </div>
                    
                    <div class = "form-group row">
                        <label class = "text-center-xs bold-xs col-sm-3 control-label text-right">Username</label>
                        
                        <div class = "col-sm-6">
                            <p class = "form-control-static text-left text-center-xs break-words">{permission.customer}</p>
                        </div>
                    </div>
                    
                    <div class = "form-group row">
                        <label class = "col-sm-3 control-label text-right text-right">Permissions</label>
                        
                        <div class = "col-sm-6 text-left">
                            <div class = "checkbox">
                                <label>
                                    <input type = "checkbox" id = "permission-read" disabled={loading} name = "permissions[]" value = "read" checked={readPermission} onChange={() => { this.setState({readPermission: !readPermission}) }} />
                                    
                                    <span>View Charting Data</span>
                                </label>
                            </div>
                            
                            <div class = "checkbox">
                                <label>
                                    <input type = "checkbox" id = "permission-write" disabled={loading} name = "permissions[]" value = "write" checked={writePermission} onChange={() => { this.setState({writePermission: !writePermission}) }} />
                                    
                                    <span>Complete Exercises with Student</span>
                                </label>
                            </div>
                        </div>
                    </div>

                    
                    <button type = "submit" class = "btn btn-secondary btn-lg" disabled={loading} >{submitting ?
                    <ClipLoader
							size={20}
							color={"#123abc"}
							loading={submitting}
							/> : "Edit"}</button>
                </form>
            </React.Fragment>
        )
    }
}

export default Edit
